module.exports = __webpack_public_path__ + "img/athletics.707fafa0.svg";